import React from 'react';
import ListOfCities from '../../../ListOfCities';
import * as S from './Styled';

export default ({ isLoading, visible, onOk, location, prop, ...rest }) => {
  return (
    <S.Cities
      title={null}
      visible={visible}
      footer={null}
      width={'auto'}
      wrapClassName="cities"
      {...rest}
    >
      <ListOfCities
        handleSelectCity={onOk}
        location={location}
        visible={visible}
      />
    </S.Cities>
  );
};
